import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useButtonNavHandler = (path?: string) => {
  //const { search } = useLocation();
  const navigate = useNavigate();
  const onClickHandler = useCallback(() => {
    navigate(`${path}`);
  }, [navigate, path]);

  return path ? onClickHandler : undefined;
};
